/*
  CEBE theme — assets/cebe-product.js, part 2 of 2: add forms, variants, gallery, buy bar and start.
  Load all parts in this order, each with defer: cebe-product-part-1.js, cebe-product-part-2.js.
  Made by website/review/sammel-2026-10-03/werkzeuge/zusammenfuehren.py from assets/cebe-product.js (MD5 6efbd99c46b8b988275afc40f21524c2);
  every Shopify upload file must stay below 26 000 bytes. Between the markers stands the original code; the only change:
  a name that one part changes and another reads, or that comes from a later part, reads cebeShared.<name> (one private
  object, window.__cebeParts.product). See website/review/sammel-2026-10-03/TEILUNG.md.
*/
(function () {
  'use strict';

  var cebeShared = (window.__cebeParts = window.__cebeParts || {}).product || (window.__cebeParts.product = {});
  if (cebeShared.done !== 1) return; // part 1 did not finish (error or early return): stop, as the single file would
  var config = cebeShared.config;
  var $ = cebeShared.$;
  var $$ = cebeShared.$$;
  var announce = cebeShared.announce;
  var cart = cebeShared.cart;
  var reduceMotion = cebeShared.reduceMotion;
  var showFormError = cebeShared.showFormError;
  var BUSY_DELAY = cebeShared.BUSY_DELAY;
  var DONE_TIME = cebeShared.DONE_TIME;
  var WAIT = cebeShared.WAIT;
  var LIMIT = cebeShared.LIMIT;
  var RESERVE = cebeShared.RESERVE;
  var GRACE = cebeShared.GRACE;
  var ARM = cebeShared.ARM;
  var UNCONFIRMED = cebeShared.UNCONFIRMED;
  var MISSING = cebeShared.MISSING;
  var resets = cebeShared.resets;
  var forms = cebeShared.forms;
  var doubts = cebeShared.doubts;
  var notify = cebeShared.notify;
  var live = cebeShared.live;
  var onItsWay = cebeShared.onItsWay;
  var shows = cebeShared.shows;
  var markUnsure = cebeShared.markUnsure;
  var drawnQuantity = cebeShared.drawnQuantity;
  var drawFrom = cebeShared.drawFrom;
  var sectionOf = cebeShared.sectionOf;
  var within = cebeShared.within;
  var timedFetch = cebeShared.timedFetch;
  var postAdd = cebeShared.postAdd;
  var reload = cebeShared.reload;
  var cartQuantity = cebeShared.cartQuantity;
  var setState = cebeShared.setState;
  var busyText = cebeShared.busyText;
  var variantOf = cebeShared.variantOf;
  var relabel = cebeShared.relabel;
  var retell = cebeShared.retell;
  var confirmed = cebeShared.confirmed;
  var refused = cebeShared.refused;
  var addedMessage = cebeShared.addedMessage;

  /* ---- assets/cebe-product.js, lines 330–836 ---- */

  function initProductForms() {
    $$('[data-cebe-product-form]').forEach(function (form) {
      var busy = false;
      var attempt = 0; // every tap gets the next number; after a reset (back-forward cache) an older one stays silent
      var busyTimer = 0;
      var doneTimer = 0;
      // The form button and the phone buy bar button (form="…") move together.
      var buttons = $$('[data-cebe-add]').filter(function (button) {
        return button.form === form;
      });
      forms.push({ form: form, buttons: buttons });

      resets.push(function () {
        attempt += 1;
        window.clearTimeout(busyTimer);
        window.clearTimeout(doneTimer);
        busy = false;
        setState(buttons, 'idle');
      });

      form.addEventListener('submit', function (event) {
        if (!cart.available()) return;
        event.preventDefault();
        if (busy) return; // a double tap must not add twice
        busy = true;
        var ticket = ++attempt;
        showFormError(form, '');
        window.clearTimeout(doneTimer);
        setState(buttons, 'pending');
        busyTimer = window.setTimeout(function () {
          setState(buttons, 'busy');
        }, BUSY_DELAY);

        var body = new FormData(form);
        body.append('sections', cart.sectionId());
        body.append('sections_url', window.location.pathname);
        var trigger = event.submitter || form.querySelector('[data-cebe-add]');
        var readable = typeof body.get === 'function';
        var id = readable ? String(body.get('id') || '') : '';
        var want = Math.max(1, (readable && parseInt(body.get('quantity'), 10)) || 1);
        var headers = { Accept: 'application/json' };
        var cartUrl = (config.routes.cart || '/cart') + '.js';
        var job = { open: true, failed: false, followed: false, confirmed: false, landed: false, stops: [], draw: null, release: null };
        // Shortly before the limit: a new tap that waits for an earlier add reads the cart once more.
        var lastCall = new Promise(function (resolve) {
          window.setTimeout(resolve, LIMIT - RESERVE);
        });
        // The unconfirmed add this tap is about, if any: then it only checks (also if that add is settled while the tap
        // waits for the cart queue), unless it is the deliberate "Add anyway".
        var tapped = (id && doubts[id]) || null;
        if (tapped) tapped.watch = job;
        busyText(buttons, Boolean(tapped && !(cebeShared.anyway[id] && cebeShared.anyway[id].armed)));

        // The tap is answered once: "Added" or an error line. Whatever of it is still on its way changes nothing after.
        function close() {
          if (!job.open) return false;
          job.open = false;
          if (ticket !== attempt) return false; // back from the back-forward cache: that reset rules
          busy = false;
          window.clearTimeout(busyTimer);
          return true;
        }

        // Confirmed by an answer or by the cart while the tap is open: the doubt about this coffee is gone (a request of
        // it still on its way no longer holds "Check out").
        function succeed(data, html) {
          job.confirmed = true;
          if (id) {
            if (doubts[id]) {
              doubts[id].result = 'applied';
              delete doubts[id];
              notify();
            }
            delete cebeShared.anyway[id];
            relabel();
          }
          if (!close()) return;
          drawFrom(job, html, { keepScroll: false });
          cart.open(trigger);
          announce(addedMessage(data));
          setState(buttons, 'done');
          doneTimer = window.setTimeout(function () {
            setState(buttons, 'idle');
          }, DONE_TIME);
        }

        // The tap ends without "Added". message: a text for an unconfirmed add; else the one for the error.
        function fail(error, message) {
          if (!close()) return;
          job.failed = true;
          setState(buttons, 'idle');
          relabel();
          var text = message || config.errorText(error);
          showFormError(form, text); // shown here, spoken once: the line is not a live region
          announce(text);
        }

        // "Add anyway" for this coffee; a tap on it counts only after ARM (a double tap only reads again).
        function offer() {
          var mark = { armed: false };
          cebeShared.anyway[id] = mark;
          window.setTimeout(function () {
            mark.armed = true;
          }, ARM);
        }

        // The cart does not show it (or cannot be read: seen = null). Number and drawer still take the server's state
        // (another tab may have changed it), without opening the drawer. Is nothing on its way any more, the customer
        // decides: "Add anyway".
        function unconfirmed(seen, doubt) {
          if (seen && seen.html) drawFrom(job, seen.html, { keepScroll: true });
          if (!live(doubt)) return fail();
          if (seen && !onItsWay(doubt.flight)) {
            offer();
            return fail(null, MISSING);
          }
          fail(null, UNCONFIRMED);
        }

        // The cart as the server holds it now: how many of this variant (and one of its items), and the drawer read in
        // the same moment. /cart.js decides; the drawer gets a short grace (without it, "Added" lets it reload itself).
        function readCart() {
          var read = timedFetch(job, cartUrl, { headers: headers }, WAIT);
          var drawer = timedFetch(job, (config.routes.root || '/') + '?sections=' + cart.sectionId(), { headers: headers }, WAIT).then(
            function (sections) {
              return (sections && sections[cart.sectionId()]) || null;
            },
            function () {
              return null;
            }
          );
          return read.then(function (data) {
            var seen = cartQuantity(data, id);
            return within(job, drawer, GRACE).then(
              function (html) {
                seen.html = html;
                return seen;
              },
              function () {
                seen.html = null;
                return seen;
              }
            );
          });
        }

        // Waits for the request of an add on its way: its answer decides, else the cart. The first tap waits WAIT; a new
        // tap waits until shortly before its limit and then reads the cart once more.
        function follow(flight, doubt, retry) {
          var answer = retry
            ? Promise.race([
                flight.answer,
                lastCall.then(function () {
                  throw { timeout: true };
                })
              ])
            : flight.answer;
          return within(job, answer, retry ? null : WAIT).then(
            function (data) {
              if (job.open) succeed(data, sectionOf(data));
            },
            function (error) {
              if (!job.open) return;
              if (error && error.rejected) {
                // Refused by the cart (422 stock, 400): that request added nothing.
                if (live(doubt) && doubt.flight === flight) refused(doubt, error);
                return fail(error);
              }
              if (!doubt) return fail(error);
              return check(doubt, retry); // no connection, no answer (yet), 5xx or an HTML page: the cart decides
            }
          );
        }

        // Sends the add; base = the quantity in the cart before it. An unconfirmed add of this coffee that it replaces
        // ("Add anyway") may still be carried out: a ghost, until the customer decides at "Check out".
        function send(base) {
          var flight = postAdd(id, body);
          var doubt = null;
          if (id) {
            cebeShared.serial += 1;
            if (doubts[id]) cebeShared.ghosts[id] = true;
            doubt = flight.doubt = doubts[id] = { id: id, base: base, want: want, target: base + want, flight: flight, form: form, blind: false, result: '', accepted: false, watch: null };
            delete cebeShared.anyway[id];
            relabel();
            notify();
          }
          // Its answer, whenever it comes: while this tap is open (also while the cart is read), it is "Added". After the
          // tap was answered without it, it is drawn quietly (drawer and number; the drawer stays shut), spoken, and the
          // line goes. A newer tap on this coffee that is still open says it instead.
          flight.answer.then(
            function (data) {
              var html = sectionOf(data);
              if (job.open) return succeed(data, html);
              job.landed = true;
              if (!live(doubt)) return; // already confirmed (by the cart or a newer tap)
              doubt.result = 'applied';
              if (doubt.watch && doubt.watch.open) return;
              (html && drawFrom(job, html, { keepScroll: true }) ? Promise.resolve(true) : reload()).then(function (drawn) {
                if (!drawn) return markUnsure(); // stays unconfirmed until a tap or "Check out" reads the cart
                if (confirmed(doubt)) announce(addedMessage(data));
              });
            },
            function (error) {
              // Refused after the tap was answered: it added nothing. The line says so instead of "may have been added".
              if (job.open || !error || !error.rejected || !live(doubt)) return;
              refused(doubt, error);
              if (doubt.watch && doubt.watch.open) return;
              var text = config.errorText(error);
              retell(id, text);
              announce(text);
            }
          );
          return follow(flight, doubt, false);
        }

        // Reads the cart. retry = true: a new tap on a coffee whose add is unconfirmed. It never adds: is the earlier
        // add still on its way, it waits for that one, then reads once more; else the customer decides (unconfirmed).
        function check(doubt, retry) {
          var pending = onItsWay(doubt.flight) ? doubt.flight : null; // then the read alone cannot say "not added"
          doubt.watch = job;
          return readCart().then(
            function (seen) {
              if (!job.open) return;
              if (shows(doubt, seen.quantity)) return succeed(seen.item, seen.html);
              if (doubt.result === 'refused') return fail(doubt.error); // refused meanwhile: nothing was added
              if (retry && pending && !job.followed) {
                job.followed = true;
                return follow(pending, doubt, true); // if it has answered meanwhile, that answer decides at once
              }
              unconfirmed(seen, doubt);
            },
            function () {
              unconfirmed(null, doubt); // the cart cannot be read: nothing is sent; a new tap reads it first
            }
          );
        }

        // "Add anyway": the customer's own decision. One more read: there now → "Added"; else it is added again.
        function decide(doubt) {
          doubt.watch = job;
          return timedFetch(job, cartUrl, { headers: headers }, WAIT).then(
            function (data) {
              if (!job.open) return;
              var seen = cartQuantity(data, id);
              if (shows(doubt, seen.quantity)) return succeed(seen.item, null); // there now, or confirmed meanwhile
              busyText(buttons, false);
              return send(seen.quantity);
            },
            function () {
              fail(); // the cart cannot be read: nothing is sent; "Add anyway" stays
            }
          );
        }

        // The first step, once the cart queue is free.
        function start() {
          var doubt = (id && doubts[id]) || tapped;
          var deliberate = Boolean(doubt && live(doubt) && cebeShared.anyway[id] && cebeShared.anyway[id].armed);
          busyText(buttons, Boolean(doubt) && !deliberate);
          if (deliberate) return decide(doubt);
          if (doubt) return check(doubt, true);
          var base = id ? drawnQuantity(id) : 0;
          if (base !== null) return send(base);
          // The drawer may be behind the server (a change that failed, a drawing still open): the cart first.
          return timedFetch(job, cartUrl, { headers: headers }, WAIT).then(
            function (data) {
              if (job.open) return send(cartQuantity(data, id).quantity);
            },
            function () {
              fail(); // the cart cannot be read: nothing is sent
            }
          );
        }

        // 15 s after the tap: stop what this tap still waits for (an add request on its way goes on), say so, free the
        // cart queue. Its result tells a waiting "Check out" whether this add is confirmed.
        window.setTimeout(function () {
          if (job.open) {
            job.stops.forEach(function (stop) {
              stop();
            });
            fail(null, id && doubts[id] && !cebeShared.anyway[id] ? UNCONFIRMED : null);
          }
          if (job.release) job.release(job.confirmed || job.landed);
        }, LIMIT);

        // In the cart queue: open quantity changes go first, and none can overwrite this add. While this coffee's add is
        // unconfirmed and still on its way, the queue stays held ("Check out" waits for it), up to the limit. The queue
        // learns whether the add is confirmed (assets/cebe.js, exclusive).
        cart.run(function (draw) {
          job.draw = draw;
          return new Promise(function (release) {
            job.release = release;
            if (!job.open) return release(false); // answered at the limit while it waited for the queue: nothing is sent
            start()
              .then(null, function () {})
              .then(function () {
                var doubt = id && doubts[id];
                return doubt && onItsWay(doubt.flight) && doubt.flight.answer.then(null, function () {});
              })
              .then(function () {
                release(job.confirmed || job.landed);
              });
          });
        });
      });
    });

    // For "Check out" (assets/cebe.js): the adds of this page whose outcome is not confirmed.
    if (forms.length && cart.hold) {
      cart.hold({
        // 'travelling': an add is on its way; 'unclear': unconfirmed (or a ghost), nothing on its way; '': nothing open.
        state: function () {
          var state = '';
          cebeShared.travelling.forEach(function (flight) {
            if (!flight.doubt || live(flight.doubt)) state = 'travelling';
          });
          if (state) return state;
          Object.keys(doubts).forEach(function (id) {
            if (!doubts[id].accepted) state = 'unclear';
          });
          return state || (Object.keys(cebeShared.ghosts).length ? 'unclear' : '');
        },
        // The cart as the server holds it now (read and drawn by "Check out"): what it confirms.
        check: function (data) {
          Object.keys(doubts).forEach(function (id) {
            if (shows(doubts[id], cartQuantity(data, id).quantity)) confirmed(doubts[id]);
          });
        },
        // The customer has seen the cart and checks out again. The next tap on such a coffee still reads first.
        accept: function () {
          Object.keys(doubts).forEach(function (id) {
            doubts[id].accepted = true;
          });
          cebeShared.ghosts = {};
        },
        serial: function () {
          return cebeShared.serial;
        },
        // A quantity change of a line (key "variant:…") is on its way: until its answer, the cart's number of that coffee
        // says nothing about an add of it.
        changing: function (key) {
          var doubt = doubts[String(key).split(':')[0]];
          if (doubt) doubt.blind = true;
        },
        // Its answer, the cart as the server holds it now: an add still open would come on top of that number. A late
        // answer that could not be drawn is drawn by this one.
        changed: function (key, data) {
          var doubt = doubts[String(key).split(':')[0]];
          if (!doubt) return;
          if (doubt.result === 'applied') return confirmed(doubt);
          doubt.base = cartQuantity(data, doubt.id).quantity;
          doubt.target = doubt.base + doubt.want;
          doubt.blind = false;
        }
      });
    }

    // Back from the checkout (back-forward cache): no spinner, no "Added", no old line or "Add anyway" (the next tap on
    // an unconfirmed coffee reads the cart again). cebe.js reloads the drawer now; until it has drawn, the next add reads
    // the cart first.
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      markUnsure();
      cebeShared.anyway = {};
      relabel();
      forms.forEach(function (entry) {
        showFormError(entry.form, '');
      });
      resets.forEach(function (reset) {
        reset();
      });
    });
  }

  // After a variant change: label and error line speak for the coffee now chosen.
  function speakFor(root) {
    relabel();
    forms.forEach(function (entry) {
      if (!root.contains(entry.form)) return;
      var id = variantOf(entry.form);
      showFormError(entry.form, id && doubts[id] ? (cebeShared.anyway[id] ? MISSING : UNCONFIRMED) : '');
    });
  }
  /* ---------- Variant change: price, unit price, details and image come from the server ---------- */
  function initVariants() {
    $$('[data-cebe-product]').forEach(function (root) {
      var sectionId = root.dataset.sectionId;
      var url = root.dataset.url;
      var sequence = 0;

      root.addEventListener('change', function (event) {
        if (!event.target.matches('[data-cebe-variant]')) return;
        var variantId = event.target.value;
        var ticket = ++sequence; // only the newest answer may update the page
        speakFor(root); // at once, also if the answer below fails

        fetch(url + '?variant=' + encodeURIComponent(variantId) + '&section_id=' + encodeURIComponent(sectionId))
          .then(function (response) {
            if (!response.ok) throw new Error(String(response.status));
            return response.text();
          })
          .then(function (html) {
            if (ticket !== sequence) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');

            var freshPrices = $$('[data-cebe-price]', doc);
            $$('[data-cebe-price]', root).forEach(function (node, index) {
              if (freshPrices[index]) node.replaceWith(freshPrices[index]);
            });

            $$('[data-cebe-refresh]', root).forEach(function (node) {
              var fresh = $('[data-cebe-refresh="' + node.dataset.cebeRefresh + '"]', doc);
              if (!fresh) return;
              if (fresh.hasAttribute('data-cebe-reveal')) fresh.classList.add('is-visible');
              node.replaceWith(fresh);
            });

            var freshButtons = $$('[data-cebe-add]', doc);
            $$('[data-cebe-add]', root).forEach(function (button, index) {
              var fresh = freshButtons[index];
              if (!fresh) return;
              button.disabled = fresh.disabled;
              // Only the label: busy and done markup stay, a running "Added" stays too.
              var label = $('[data-cebe-add-label]', button);
              var freshLabel = $('[data-cebe-add-label]', fresh);
              if (label && freshLabel) {
                label.textContent = freshLabel.textContent.trim();
                label.cebeOwn = undefined;
              }
            });
            relabel(); // "Add anyway" if this variant waits for that decision

            var freshSlide = $('[data-cebe-slide]:not([hidden])', doc);
            if (freshSlide) showSlide(root, freshSlide.dataset.cebeSlide);

            window.history.replaceState({}, '', url + '?variant=' + encodeURIComponent(variantId));
            var amount = $('.cebe-product__info .cebe-price__amount', root);
            if (amount) announce(amount.textContent.trim());
          })
          .catch(function () {
            if (ticket === sequence) announce(config.strings.error);
          });
      });
    });
  }

  /* ---------- Gallery thumbnails ---------- */
  function showSlide(scope, id) {
    $$('[data-cebe-slide]', scope).forEach(function (slide) {
      slide.hidden = slide.dataset.cebeSlide !== id;
    });
    $$('[data-cebe-thumb]', scope).forEach(function (thumb) {
      thumb.setAttribute('aria-current', String(thumb.dataset.cebeThumb === id));
    });
  }

  function initGallery() {
    $$('[data-cebe-gallery]').forEach(function (gallery) {
      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-cebe-thumb]');
        if (thumb) showSlide(gallery, thumb.dataset.cebeThumb);
      });
    });
  }

  /* ---------- Phones: sticky buy bar once the buy area is out of view ---------- */
  function initBuyBar() {
    var bar = $('[data-cebe-buybar]');
    var anchor = $('[data-cebe-product-form] [data-cebe-add]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    function setVisible(visible) {
      if (visible) bar.setAttribute('data-visible', '');
      else bar.removeAttribute('data-visible');
      // Keep the end of the page (footer, VAT line) clear of the bar.
      var height = visible && window.getComputedStyle(bar).display !== 'none' ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--cebe-buybar-space', height + 'px');
    }

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    observer.observe(anchor);
  }

  /* ---------- QR code on the bag: ?von=tuete jumps to "Already have this bag?" ---------- */
  function initBagJump() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('von') !== 'tuete') return;
    var target = document.getElementById('have-this-bag');
    if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function init() {
    initProductForms();
    initVariants();
    initGallery();
    initBuyBar();
    initBagJump();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* ---- end of lines 330–836 ---- */

  cebeShared.done = 2;
})();
